import { render, staticRenderFns } from "./FolderTree.vue?vue&type=template&id=108d75f4&"
import script from "./FolderTree.vue?vue&type=script&lang=js&"
export * from "./FolderTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports